import { z } from 'zod';

import { territorySchema } from '../schema/Territory.ts';
import { validateData } from '../utils/utils.ts';
import { api } from './client.ts';
import { getTerritoriesUrl, getTerritoryUrl } from './constants.ts';

export async function getTerritories(signal?: AbortSignal) {
  const { data } = await api.get(getTerritoriesUrl, { signal });
  return validateData(z.array(territorySchema), data, 'Territories');
}

export async function getTerritory(territorySlug: string, signal?: AbortSignal) {
  const { data } = await api.get(getTerritoryUrl(territorySlug), { signal });
  return validateData(territorySchema, data, 'Territory');
}
